import * as React from 'react';
import { FunctionComponent } from 'react';

import { Flex } from 'basecamp';

type Props = {
	value: string;
};

const AdhocRenderer: FunctionComponent<Props> = ({ value }) => {
	/**
	 ** Renderer
	 */
	const renderer = (bg: string) => {
		return (
			<Flex
				dataTest="adhoc-group-cell"
				data-group={value ?? 'none'}
				width={1}
				height="100%"
				bg={`${bg}`}
			/>
		);
	};

	/**
	 ** Render Component
	 */
	switch (value) {
		case 'sage':
			return renderer('ADHOC.connect.0'); // Sage green
		case 'lavender':
			return renderer('ADHOC.connect.1'); // Lavender mist
		case 'orchid':
			return renderer('ADHOC.connect.2'); // Orchid pink
		case 'sky':
			return renderer('ADHOC.connect.3'); // Sky blue
		case 'buttercup':
			return renderer('ADHOC.connect.4'); // Buttercup yellow
		case 'peach':
			return renderer('ADHOC.connect.5'); // Peach sorbet
		case 'rose':
			return renderer('ADHOC.connect.6'); // Rose petal
		default:
			return renderer('ADHOC.connect.0'); // Default to sage green
	}
};

export default AdhocRenderer;
